import React from 'react';
// import { oneDecimal } from '../../helpers/formatters';
import { labelMatcher } from '../../helpers/label-mapper';
import styles from './region-entity-table.module.scss';
import { connect } from 'react-redux';
import * as selectors from '../../reducers';
import PropTypes from 'prop-types';
import {
  setActiveEntity,
  setComparedEntity,
  setActivePage,
} from '../../actions/ui';
import { humanizeNumber } from '../../helpers/formatters';

//  Quick fix
const numberTypes = {
  qtripsNationalNetworkIndicativeTotalProjectsCost: {
    unit: 'currency',
    omitDecimals: false,
  },
  qtripsStateNetworkIndicativeTotalCost: {
    unit: 'currency',
    omitDecimals: false,
  },
  qtripsLocalNetworkIndicativeTotalCost: {
    unit: 'currency',
    omitDecimals: false,
  },
  lengthOfManagedRoads: { unit: 'kilometer', omitDecimals: false },
  numberOfBridges: { unit: 'number', omitDecimals: true },
  numberOfBridgesCouncilManaged: { unit: 'number', omitDecimals: true },
  kilometresOfCouncilManagedRoad: { unit: 'kilometer', omitDecimals: true },
  totalCapitalExpenditureOnRoads: { unit: 'currency', omitDecimals: true },
  totalMaintenanceExpenditureOnRoads: { unit: 'currency', omitDecimals: true },
  writtenDownValueOfRoadsBridgesAndMajorCulvert: {
    unit: 'currency',
    omitDecimals: false,
  },
  valuationLastPeformed: { unit: 'text', omitDecimals: true },
};

const RegionInfoGrid = ({
  region,
  setActiveEntity,
  setComparedEntity,
  setActivePage,
  isMobile,
  title,
  fields,
  hasHeaderCol,
}) => {
  console.log(fields);
  return (
    <div style={{ width: '100%' }}>
      <div style={{ marginBottom: 30 }}>
        <span className={styles.tableHeaderText}>{title}</span>
      </div>
      <div style={{ marginBottom: 30 }}>
        <span
          className={`${styles.dataCaption} ${styles.regionGridSubheading}`}
        >
          In this council
        </span>
      </div>
      <div className={styles.regionGridWrapper}>
        {hasHeaderCol && (
          <div className={styles.headerCol}>
            <div className={`${styles.dataCaption} ${styles.dataSuperscript}`}>
              Transport Entity
            </div>
            <div
              className={`${styles.gridValueText}`}
              style={{ textDecoration: 'underline' }}
              onClick={() => {
                setActiveEntity('DTMR');
                setComparedEntity(null);
                setActivePage('entity');
              }}
            >
              Department of Transport and Main Roads
            </div>
          </div>
        )}
        <div
          className={`${styles.gridBoxArea} ${
            hasHeaderCol ? styles.narrowGridBox : styles.wideGridBox
          }`}
        >
          {fields.map((key) => {
            const value = region[key];
            return (
              <div key={key} className={styles.regionGridFactBox}>
                <div
                  className={`${styles.dataCaption} ${styles.dataSuperscript}`}
                >
                  {labelMatcher(key)}
                </div>
                <div className={`${styles.gridValueText}`}>
                  {humanizeNumber(
                    value,
                    numberTypes[key].unit,
                    numberTypes[key].omitDecimals
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  setActiveEntity,
  setComparedEntity,
  setActivePage,
};

const mapStateToProps = (state, props) => ({
  isMobile: selectors.getIsMobile(state),
});

RegionInfoGrid.propTypes = {
  region: PropTypes.object,
  setActiveEntity: PropTypes.func,
  setActivePage: PropTypes.func,
  setComparedEntity: PropTypes.func,
};

const RegionGrid = connect(mapStateToProps, mapDispatchToProps)(RegionInfoGrid);
export { RegionGrid };



// WEBPACK FOOTER //
// ./src/components/region-entity-table/region-info-grid.js